import Vue from 'vue'
import App from './App'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: '',
//   router
// })

Vue.use(VueGoogleMaps, {
  load: {
    key: '',
    libraries: 'places' // necessary for places input
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
const _vue = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

window._vuePrerender = _vue



// WEBPACK FOOTER //
// ./src/main.js